import {
  FeedbackStatusEnum,
  useFeedbackList,
  useFeedbackStatusEnumText,
} from '@services/feedback'
import { IconEye } from '@shared/icons'
import useLocationSearch from '@shared/innmaxLib/hooks/useLocationSearch'
import useModal from '@shared/innmaxLib/hooks/useModal'
import useSearch from '@shared/innmaxLib/hooks/useSearch'
import { Flex } from '@shared/innmaxUI'
import { Select } from '@shared/innmaxUI/Form'
import Layout from '@shared/Layout'
import Table from '@shared/Table'
import { Form, Space } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { isEmpty, values } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'src/components/Button'
import { FormItem } from 'src/components/Form'
import DetailModal from './DetailModal'

function FeedbackManagement() {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const queryParams = useLocationSearch()

  const [searchParams] = React.useState(queryParams)

  const { handleSearch, handleTableChange, query } = useSearch({
    form,
    keepPreviousQuery: true,
  })

  const { dataSource, isLoading, refetch } = useFeedbackList(query)

  const { item: data, ...editModal } = useModal({
    content: dataSource.content,
  })

  const columns: ColumnsType<any> = [
    {
      title: t('common:view'),
      key: 'view',
      align: 'center',
      width: 80,
      render: (_, r) => (
        <Space>
          {/* {r?.nextChargingFee ? (
            <span className="text-[#FFCC2B]">*</span>
          ) : (
            <span>&nbsp;</span>
          )} */}
          <IconEye
            data-id={r.id}
            onClick={e => {
              editModal.toggle(e)
            }}
          />
        </Space>
      ),
    },
    {
      title: '表單編號',
      dataIndex: 'formNo',
    },

    {
      title: 'email',
      dataIndex: 'email',
    },
    {
      title: '公司名稱',
      dataIndex: 'companyName',
    },
    {
      title: '狀態',
      dataIndex: 'statusStr',
      render: (_, r) => (
        <span style={{ color: r.statusColor || 'inherit' }}>{r.statusStr}</span>
      ),
    },
    {
      title: '建立時間',
      dataIndex: 'createAtStr',
    },
  ]

  React.useEffect(() => {
    if (!searchParams || isEmpty(searchParams)) {
      return
    }

    const device = searchParams?.device
    if (device) {
      const [id] = device.split(',')[1]
      if (id) {
        editModal.open({ id })
      }
    }
  }, [searchParams]) //eslint-disable-line

  const { enumToText } = useFeedbackStatusEnumText()

  return (
    <>
      {editModal.visible && (
        <DetailModal
          item={data}
          onOk={refetch}
          onCancel={editModal.close}
          onOkDeletion={() => {
            refetch()
            editModal.close()
          }}
        />
      )}
      <Layout>
        <Form layout="inline" form={form}>
          <FormItem name="status" label="處理狀態" className="w-264">
            <Select allowClear placeholder="請選擇處理狀態">
              {values(FeedbackStatusEnum).map(status => (
                <Select.Option key={status} value={status}>
                  {enumToText(status)}
                </Select.Option>
              ))}
            </Select>
          </FormItem>

          <FormItem.Button>
            <Button.Search onClick={handleSearch} />
          </FormItem.Button>
        </Form>
        <div className="mt-44 mb-16">
          <Flex between>
            <Space>
              <Table.RowCount count={dataSource.total} />
            </Space>
            <Space size={16}>
              {/* <Button.ManualAdd
                onClick={editModal.toggle}
                actionType={ActionTypes.CREATABLE}
              /> */}
            </Space>
          </Flex>
        </div>
        <Table
          className="w-full"
          dataSource={dataSource}
          loading={isLoading}
          columns={columns}
          onChange={handleTableChange}
        />
      </Layout>
    </>
  )
}

export default FeedbackManagement
